// An unrecognized IANA zone string throws a RangeError from Intl rather than failing
// gracefully, so an unvalidated `timezone` (e.g. a bad call_at_timezone from the API)
// would crash the caller instead of just rendering in the wrong zone.
function resolveTimezone(timezone) {
    try {
        // eslint-disable-next-line no-new
        new Intl.DateTimeFormat(undefined, { timeZone: timezone });
        return timezone;
    } catch (error) {
        return 'UTC';
    }
}

// The backend parses fromDateTimeLocal's output in the demo owner's test-company
// timezone (UpdateDemoCompanyRequest's contacts.*.reminder_date rule), so the field
// must render in that same zone, not the browser's — otherwise the two disagree.
export function toDateTimeLocal(iso, timezone = 'UTC') {
    if (!iso) {
        return '';
    }

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: resolveTimezone(timezone),
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    });

    const parts = formatter.formatToParts(date).reduce((values, part) => {
        values[part.type] = part.value;
        return values;
    }, {});

    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

// Display-only (never round-tripped) timestamp, e.g. "9/24/2026 3:24 pm CDT" - mirrors
// production's Blade `format('n/j/Y g:i a T')`, lowercasing Intl's AM/PM to match it.
export function formatDisplayDateTime(iso, timezone = 'UTC') {
    if (!iso) {
        return '';
    }

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: resolveTimezone(timezone),
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short',
    });

    return formatter.format(date)
        .replace(', ', ' ')
        .replace(/\b(AM|PM)\b/, (period) => period.toLowerCase());
}

export function fromDateTimeLocal(value) {
    if (!value) {
        return null;
    }

    return value.replace('T', ' ');
}

export function formUrlEncoded(pairs) {
    const params = new URLSearchParams();
    pairs.forEach(([key, value]) => params.append(key, value));

    return params.toString();
}
